import { createSelector } from 'reselect';
import { RootState } from 'redux/schemas';
import { VideoPracticeSubmission } from 'redux/schemas/models/video-practice';
import { SliderAction } from 'practice_room/components/shared/user-submission-slider';
import { filter } from 'lodash';

const getPracticeActivitiesIdsAvailableForfeedback = (state: RootState) => (
  state.models.courses[state.app.currentCatalogId].practiceActivitiesAvailableForFeedback ?? []
);

const practiceActvities = (state: RootState) => state.models.practiceActivities;

const practiceSubmissions = (state: RootState) => state.models.practiceSubmissions;

const feedbackGalleryIds = (state: RootState, practiceFeedbackActivityId?: number) => {
  const id = practiceFeedbackActivityId ?? state.app.videoPracticeFeedback.feedbackCriteriaId;
  return state.models.practiceFeedbackActivities?.[id]?.feedbackGalleryIds ?? [];
};

export const getPracticeActivitiesAvailable = createSelector(
  [getPracticeActivitiesIdsAvailableForfeedback, practiceActvities],
  (ids, activities) => (ids || []).map(id => activities[id]),
);

export const getFeedbackGallerySubmissions = createSelector(
  [
    (state, practiceFeedbackActivityId) => feedbackGalleryIds(state, practiceFeedbackActivityId),
    practiceSubmissions,
  ], (ids, submissions) => (ids || []).map(id => submissions[id]),
);

export const nextAndPrevSubmissions = createSelector(
  [
    practiceSubmissions,
    (state, submissionId) => feedbackGalleryIds(state).findIndex(id => id === Number(submissionId)),
    (state) => feedbackGalleryIds(state),
  ], (submissions, index, ids) => {
    const nextPrev: { [key in SliderAction]: VideoPracticeSubmission } = {
      next: null,
      prev: null,
    };
    const nextSubmissionId = ids?.[index + 1];
    const prevSubmissionId = ids?.[index - 1];

    nextPrev[SliderAction.NEXT] = submissions?.[nextSubmissionId] ?? null;
    nextPrev[SliderAction.PREV] = submissions?.[prevSubmissionId] ?? null;

    return nextPrev;
  },
);

// Get all the feedback activities of the activity and return lecturePageId
export const getLecturePageIdsOfFeedbackActivities = (state: RootState, practiceActivityId) => filter(
  state.models.practiceFeedbackActivities,
  { activityId: practiceActivityId },
).map(feedbackActivity => feedbackActivity.lecturePageId);
